import { stripUndefinedProps } from '@neptune/shared/common-util';
import { GlobalWidgetConfig, SectionWidgetConfig } from '@neptune/shared/widgets-domain';

export function resolveWidgetConfig({
  sectionConfig = {},
  globalConfig,
}: {
  sectionConfig: SectionWidgetConfig | undefined;
  globalConfig: GlobalWidgetConfig;
}): GlobalWidgetConfig {
  const correctedGlobalConfig = stripUndefinedProps(globalConfig);
  const correctedSectionConfig = stripUndefinedProps(sectionConfig);

  const { mode: sectionLayoutMode, config: sectionLayoutConfig } =
    correctedSectionConfig?.layoutSettings ?? {};
  const { columnsCount: sectionColumnsCount } = sectionLayoutConfig?.gridMode ?? {};

  const { mode: globalLayoutMode, config: globalLayoutConfig } =
    correctedGlobalConfig.layoutSettings;
  const { columnsCount: globalColumnsCount } = globalLayoutConfig.gridMode;

  return {
    ...correctedGlobalConfig,
    ...correctedSectionConfig,
    layoutSettings: {
      mode: sectionLayoutMode ?? globalLayoutMode,
      config: { gridMode: { columnsCount: sectionColumnsCount ?? globalColumnsCount } },
    },
  };
}
